import React from "react";
import { TimerIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type OfferCountdownProps = {
  tone?: "light" | "dark";
};
export function OfferCountdown({
  tone = "light"
}: OfferCountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  return <div className="mt-5" role="timer" aria-live="off" data-id="element-34" data-mp="1c9zeuq20hzia">
      <p className={`flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-wide ${tone === "dark" ? "text-gold" : "text-wine"}`} data-id="element-35" data-mp="1h6g27i1e09ub">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-36" data-mp="1q8645hswar6c" />
        Promotional price ends in
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-37" data-mp="2workwlefndxl">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-38" data-mp="31m1jaqjsuzxk" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-39" data-mp="31p5ui7vomvxq">
              <span className="flex h-16 w-[72px] items-center justify-center rounded-xl bg-wine font-serif text-[34px] font-black tabular-nums text-white shadow-[0_4px_0_0_#6b1430]" data-id="element-40" data-mp="26orwnjls00c7">
                {unit.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-41" data-mp="1wtq6qljoeu8k">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-serif text-3xl font-black ${tone === "dark" ? "text-white" : "text-wine"}`} aria-hidden="true" data-id="element-42" data-mp="1e15hrf73l9a1">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}